(function () {
  function closeAasaanNewsletter(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    var popup = this.closest
      ? this.closest('.jsengo_popup')
      : document.querySelector('.jsengo_popup');

    if (!popup) {
      popup = document.querySelector('.jsengo_popup');
    }

    if (popup) {
      popup.style.display = 'none';
      popup.classList.add('d-none');
      popup.setAttribute('aria-hidden', 'true');
    }

    /* Remember dismissal for 1 day */
    document.cookie =
      'brilliant_pop_newletter=1; max-age=86400; path=/; SameSite=Lax';

    return false;
  }

  /* Capture phase makes this work even if old theme JS interferes */
  document.addEventListener(
    'click',
    function (e) {
      var closeButton = e.target.closest('.jsclosepoup');

      if (closeButton) {
        closeAasaanNewsletter.call(closeButton, e);
      }
    },
    true
  );

  /* Extra mobile touch support */
  document.addEventListener(
    'touchend',
    function (e) {
      var closeButton = e.target.closest('.jsclosepoup');

      if (closeButton) {
        closeAasaanNewsletter.call(closeButton, e);
      }
    },
    { capture: true, passive: false }
  );
})();